module.exports = __webpack_public_path__ + "img/装箱详情.580971ad.svg";